import React from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Hero from "@/components/landing/Hero";
import GalleryShowcase from "@/components/landing/GalleryShowcase";
import BrandStorySong from "@/components/landing/BrandStorySong";
import HowItWorks from "@/components/landing/HowItWorks";
import Features from "@/components/landing/Features";
import UniqueAdvantages from "@/components/landing/UniqueAdvantages";
import VoiceMessagePromo from "@/components/landing/VoiceMessagePromo";
import ComparisonTable from "@/components/landing/ComparisonTable";
import Testimonials from "@/components/landing/Testimonials";
import PricingSection from "@/components/landing/PricingSection";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import SEO, { SITE_URL } from "@/components/seo/SEO";
import { useI18n } from "@/i18n/I18nContext";
import { buildOrganizationSchema, buildWebSiteSchema, buildSoftwareApplicationSchema } from "@/lib/seoSchemas";

export default function Landing() {
  const { language } = useI18n();
  const isEn = language === "en";

  const orgDescription = isEn
    ? "AI-generated personalized songs for weddings, birthdays, births and every special occasion."
    : "Chansons personnalisées générées par IA pour mariages, anniversaires, naissances et toutes vos occasions spéciales.";
  const jsonLd = [
    buildOrganizationSchema(SITE_URL, orgDescription),
    buildWebSiteSchema(SITE_URL),
    buildSoftwareApplicationSchema({
      name: "Kalypso Music",
      description: orgDescription,
      url: SITE_URL,
    }),
  ];

  return (
    <div className="min-h-screen bg-background">
      <SEO
        title={isEn
          ? "Personalized Song with Name – AI Song Generator | Kalypso Music"
          : "Chanson Personnalisée par IA avec Prénom – Créer & Offrir | Kalypso Music"}
        description={isEn
          ? "Create and gift a personalized song in minutes: custom lyrics with their name, realistic AI vocals and cover art. The unique personalized music gift for weddings, birthdays and more."
          : "Créez et offrez une chanson personnalisée en quelques minutes : paroles sur-mesure avec prénom, voix chantée réaliste et pochette IA. Le cadeau musical unique pour mariage, anniversaire et plus."}
        path="/"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <Hero />
        <GalleryShowcase />
        <BrandStorySong />
        <HowItWorks />
        <Features />
        <UniqueAdvantages />
        <VoiceMessagePromo />
        <ComparisonTable />
        <Testimonials />
        <PricingSection />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
